function CheckConditions(
  formInfo,
  onlyAppearIfValueIs,
  onlyAppearIfValueIsNot,
  withRegardsTo
) {
  if (onlyAppearIfValueIs === false && onlyAppearIfValueIsNot === false) {
    return true;
  }
  //--
  else if (
    onlyAppearIfValueIs === true &&
    formInfo[withRegardsTo] &&
    formInfo[withRegardsTo] != ""
  ) {
    return true;
  }
  //--
  else if (
    Array.isArray(onlyAppearIfValueIs) &&
    formInfo[withRegardsTo] &&
    onlyAppearIfValueIs.includes(formInfo[withRegardsTo])
  ) {
    return true;
  }
  //--
  else if (
    onlyAppearIfValueIsNot === true &&
    (!formInfo[withRegardsTo] || formInfo[withRegardsTo] == "")
  ) {
    return true;
  }
  //--
  else if (
    Array.isArray(onlyAppearIfValueIsNot) &&
    formInfo[withRegardsTo] &&
    !onlyAppearIfValueIs.includes(formInfo[withRegardsTo])
  ) {
    return true;
  }
  //--
  else {
    return false;
  }
}
module.exports = CheckConditions;
